import { Config } from "../config/config";

export const httpHeaderHelper = {
    get httpHeader() {
        return {
            'Content-type': 'application/json',
            'Authorization': `Bearer ` + localStorage.getItem(Config.VITE_APP_ACCESS_TOKEN_KEY as string),
            'X-Client-Id': Config.VITE_APP_API_CLIENT_ID
        }
    }
};

